// extracted by mini-css-extract-plugin
export default {"imgContain":"kF","content":"lF","titleAndImage":"mF","title":"nF","text":"oF","rhodeTitle":"pF","shortHR":"qF","modal_root":"rF","x_mark":"sF","flavorStickModal":"tF","greenBox":"uF"};
    if(module.hot) {
      // 1714422956261
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  